module.exports = __webpack_public_path__ + "img/dsci0038.f25289d3.jpg";